import { ChangeDetectionStrategy, Component, ViewChild, Injector } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { PermissionFacade } from '../../../../../../modules/permission/facades/permission.facade';
// import { SessionSelectors } from '../../../../../../modules/session/session-controller/selectors';
// import { SessionStates } from '../../../../../../modules/session/session-controller/states';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { AppConfig } from '../../../../../../visa';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink2';
// import { CatalogueActions } from '../../../state-controllers/catalogue-controller/store/actions';
// import { selectRecord } from '../../../state-controllers/catalogue-controller/store/selectors/catalogue.selector';
import { TranslateService } from "@ngx-translate/core";
interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  deactivateList: boolean;
  selectedIndex: number;
}

@Component({
  selector: 'app-permission-template-edit',
  templateUrl: './permission-wizard-edit.component.html',
  styleUrls: ['./permission-wizard-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})
export class PermissionTemplateEditComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Permission Template Edit';
  protected readonly index = 1;
  protected localState: LocalState;
  protected prevLocalState: any;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(state => state.deactivateReturn);
  readonly selectedIndex$ = this.componentStore.select(state => state.selectedIndex);

  prevIndex: number;
  apiVisa = AppConfig.apiVisa;
  form: FormGroup;

  // appletSettings$ = combineLatest([
  //   this.sessionStore.select(SessionSelectors.selectMasterSettings),
  //   this.sessionStore.select(SessionSelectors.selectPersonalSettings)
  // ]).pipe(map(([a, b]) => ({...a, ...b})));

  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  //translation variable
  title: string;
  back_button: string;
  save_button: string;
  main_text: string;
  permission_definitions_text: string;
  targets_text: string;

  constructor(
    private viewColFacade: PermissionFacade,
    private readonly componentStore: ComponentStore<LocalState>,
    protected readonly store: Store,
    private injector: Injector) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.edit_permission_template;
        this.back_button = res.back_button;
        this.save_button = res.save_button;
        this.main_text = res.main;
        this.permission_definitions_text = res.permission_definitions;
        this.targets_text = res.targets;
      });
    } else {
      // Fallback if translation service is unavailable
      this.title = 'Edit Permission Template';
      this.back_button = 'Back';
      this.save_button = 'SAVE';
      this.main_text = 'Main';
      this.permission_definitions_text = 'Permission Definitions';
      this.targets_text = 'Targets';
    }
  }

  ngOnInit() {
    this.subs.sink = this.localState$.subscribe(a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.subs.sink = this.viewColFacade.prevIndex$.subscribe(resolve => this.prevIndex = resolve);
    this.subs.sink = this.viewColFacade.prevLocalState$().subscribe(resolve => this.prevLocalState = resolve);
  }

  updateMain(newForm: FormGroup){
    this.form = newForm;
  }

  disableSave() {
    return !this.form?.dirty || this.form?.invalid
  }

  onSave() {
    // this.store.select(selectRecord).pipe(
    //   map(catalogue => catalogue.bl_applet_catalog_hdr.guid.toString()),
    // )
    // .subscribe(
    //   guid =>
    //   this.store.dispatch(CatalogueActions.saveCatalogueChanges({guid ,form: this.form}))
    // ).unsubscribe();

    // this.form.markAsPristine();
    // this.form.markAsUntouched();
  }

  goToAppletDetails() {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
      deactivateAdd: true,
      deactivateReturn: true,
      deactivateList: false
    });
    this.viewColFacade.onNextAndReset(this.index, 3);
  }

  goToAppletAdd() {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
      deactivateAdd: true,
      deactivateReturn: true,
      deactivateList: true
    });
    this.viewColFacade.onNextAndReset(this.index, 4);
  }

  goToUserDetails() {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
      deactivateAdd: true,
      deactivateReturn: true,
      deactivateList: false
    });
    this.viewColFacade.onNextAndReset(this.index, 5);
  }

  goToUserAdd() {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
      deactivateAdd: true,
      deactivateReturn: true,
      deactivateList: true
    });
    this.viewColFacade.onNextAndReset(this.index, 6);
  }

  onReturn() {
   // this.store.dispatch(CatalogueActions.resetCatalogue());
    this.viewColFacade.updateInstance<LocalState>(this.prevIndex, {
      ...this.prevLocalState,
      deactivateAdd: false,
      deactivateList: false,
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  ngOnDestroy() {
    if (this.matTab) {
      this.viewColFacade.updateInstance<LocalState>(this.index, {
        ...this.localState,
        selectedIndex: this.matTab.selectedIndex,
      });
    }
    this.subs.unsubscribe();
  }

}
